import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import WLogo from "../../assets/W-Logo.png";
import Circle from "../../assets/Circle.png";
import Modals from "../Popup/Modal";
import "./Sidebar.css";
import $ from "jquery";
import { StateContext } from "../../store/StateProvider";
const Sidebar = () => {
  const [state, dispatch] = StateContext();
  const [Show, setShow] = useState(false);
  // const
  const OpenSidebarHandler = (e) => {
    e.preventDefault();
    $(".SideBar").css("transform", "translateX(0%)");
  };
  const CloseHandler = (e) => {
    e.preventDefault();
    $(".SideBar").css("transform", "translateX(-100%)");
  };
  window.addEventListener("resize", () => {
    if (window.innerWidth > 768) {
      $(".SideBar").css("transform", "translateX(0%)");
    } else if (window.innerWidth < 768) {
      $(".SideBar").css("transform", "translateX(-100%)");
    }
  });
  // model
  const ConnectWallet = (e) => {
    e.preventDefault();
    setShow(true);
  };

  React.useEffect(() => {
    var SIdebar1Li = $(".SideBarUL-1 > li");
    var Path = window.location.pathname;
    const lastItem = Path.substring(Path.lastIndexOf("/") + 1);
    let vd;
    if (lastItem === "admin") {
      vd = SIdebar1Li[3];
      $(vd).addClass("LinkActive");
    } else if (lastItem === "graph") {
      vd = SIdebar1Li[4];
      $(vd).addClass("LinkActive");
    }
  }, []);

  return (
    <>
      <Modals Show={Show} setshow={setShow} />
      <div className="col-md-1 px-0">
        <div className="LeftBarIcon">
          <a href="/" onClick={OpenSidebarHandler}>
            <i className="fa fa-bars" aria-hidden="true"></i>
          </a>
        </div>
        <div className="SideBar">
          <ul className="SideBarUL-1">
            <li className="LeftBar">
              <a href="/" onClick={CloseHandler}>
                <i className="fa fa-bars" aria-hidden="true"></i>
              </a>
            </li>
            <li>
              <NavLink to={`/`}>
                <img src={WLogo} className="img-fluid" alt="" />
              </NavLink>
            </li>
            <li className="Link1 ">
              <NavLink to={`/admin`}>
                <img
                  src={state.items.AlienNot}
                  className="img-fluid"
                  alt=""
                  onClick={ConnectWallet}
                />
              </NavLink>
            </li>
            <li className="Link1">
              <NavLink to={`/admin`}>
                <img src={state.items.Circle} className="img-fluid" alt="" />
              </NavLink>
            </li>
            <li className="Link1">
              <NavLink to={`/graph`}>
                <img src={state.items.Bar} className="img-fluid" alt="" />
              </NavLink>
            </li>
          </ul>
          <ul className="SideBarUL-2">
            <li className="Link1">
              <NavLink to={``}>
                <img src={state.items.CoyPaste} className="img-fluid" alt="" />
              </NavLink>
              {/* <NavLink to={`/`}></NavLink> */}
            </li>
            <li className="Link1">
              <NavLink to={``}>
                <img src={state.items.Dismond} className="img-fluid" alt="" />
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
